import { render, staticRenderFns } from "./viUser.vue?vue&type=template&id=50438700&scoped=true&"
import script from "./viUser.vue?vue&type=script&lang=js&"
export * from "./viUser.vue?vue&type=script&lang=js&"
import style0 from "./viUser.vue?vue&type=style&index=0&id=50438700&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50438700",
  null
  
)

export default component.exports